export default {
  data() {
    return {
      dataFrom: {},
      visible: false
    };
  },
  methods: {
    init(data) {
      Object.assign(this.dataFrom, data);
      this.dataFrom.nickName = '系统操作';
      this.visible = true;
    }
  }
};